import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        flex: 1,
        maxWidth: 1110,
        flexDirection: 'row',
        paddingLeft: 16,
        marginTop: 24,
        paddingBottom: 20,
        gap: 22,
        backgroundColor: props.colors.dirtyWhite,
        borderRadius: 12,
        alignItems: 'flex-end',
      },
    },
    {
      [maxSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        container: {
          flex: 1,
          maxWidth: 350,
          flexDirection: 'column',
          paddingLeft: 16,
          marginTop: 24,
          paddingBottom: 20,
          backgroundColor: props.colors.dirtyWhite,
          borderRadius: 12,
          alignItems: 'flex-start',
        },
      }
    },
  )();
